<template>
  <div v-if="visible" class="ai-workflow-preview">

    <div class="preview-header">
      <div class="button-group">
        <button class="discard-btn" @click="$emit('discard')">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M15 5L5 15M5 5L15 15" stroke="#EF4444" stroke-width="2" stroke-linecap="round"/>
          </svg>
          Discard
       </button>
        <span class="preview-title">Preview</span>
        <button class="accept-btn" @click="$emit('accept')">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M4 10L8 14L16 6" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        Accept
      </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AIWorkflowPreview',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
.ai-workflow-preview {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  width: 100%;
  height: 100%;
  padding: 60px 20px 60px 20px;
  pointer-events: none;
}

.preview-header {
  display: flex;
  align-items: start;
  width: 100%;
  height: 100%;
  justify-content: space-between;
  padding: 16px 32px;
  border: 2px solid #20A7C1;
  border-radius: 12px;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.15);
  pointer-events: none;
}
.button-group {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 16px;
  pointer-events: none;
}

.preview-title {
  font-family: 'Inter', sans-serif;
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  color: #333;
  pointer-events: none;
}

.discard-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 24px;
  background: white;
  border: 1px solid #EF4444;
  border-radius: 8px;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #EF4444;
  cursor: pointer;
  transition: all 0.2s;
  pointer-events: auto;
}

.discard-btn:hover {
  background: #FEE2E2;
}

.accept-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 24px;
  background: #004879;
  border: none;
  border-radius: 8px;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: white;
  cursor: pointer;
  transition: all 0.2s;
  pointer-events: auto;
}

.accept-btn:hover {
  background: #003366;
}
</style>
